import { useEffect, useRef } from 'react';
import { ComboBox, Input, Stack } from '@etg/wings';
import { useTranslation, useValidation } from '@eti/providers';
import { cx } from '@eti/styles';
import { Field as ReduxFormField } from 'redux-form';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ComboBoxComponent = _ref => {
  let {
    className,
    description,
    input,
    label,
    meta,
    name,
    noMatchLabel,
    shouldMarkInputAsRequired,
    ...rest
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const hasError = Boolean(meta.invalid && !meta.active && (input.value !== '' || meta.touched));
  const hasWarning = Boolean(meta.warning && !meta.active && (input.value !== '' || meta.touched));
  const errorId = `${name}-error`;
  const descriptionId = description ? `${name}-description` : undefined;
  const resolvedLabel = shouldMarkInputAsRequired ? nonDebugT('Input.Field.Required', label) : label;
  const labelRef = useRef(null);
  const labelIdRef = useRef();
  useEffect(() => {
    var _labelRef$current;
    labelIdRef.current = (_labelRef$current = labelRef.current) === null || _labelRef$current === void 0 || (_labelRef$current = _labelRef$current.attributes.getNamedItem('id')) === null || _labelRef$current === void 0 ? void 0 : _labelRef$current.value;
  }, [meta]);
  return /*#__PURE__*/_jsxs(Stack, {
    className: cx(className, 'etiComboBox', hasError && 'error'),
    spacing: 4,
    children: [/*#__PURE__*/_jsx(ComboBox, {
      "aria-labelledby": `${labelIdRef.current} ${errorId}`,
      descriptionId: descriptionId,
      errorId: errorId,
      hasError: hasError,
      hasWarning: hasWarning,
      label: resolvedLabel,
      labelRef: labelRef,
      noMatchLabel: noMatchLabel !== null && noMatchLabel !== void 0 ? noMatchLabel : t('Input.Field.ComboBox.NoMatch.Label'),
      ...rest,
      ...input,
      onBlur: () => input.onBlur(input.value),
      required: Boolean(shouldMarkInputAsRequired)
    }), (Boolean(shouldMarkInputAsRequired) || descriptionId) && /*#__PURE__*/_jsx(Input.Meta, {
      description: description,
      descriptionId: descriptionId,
      error: meta.error,
      errorId: errorId,
      hasError: hasError,
      hasWarning: hasWarning,
      warning: meta.warning
    })]
  });
};
function ConnectedComboBox(_ref2) {
  let {
    format,
    name,
    normalize,
    onBlur,
    onChange,
    onFocus,
    validationRuleName,
    warningRuleName,
    ...props
  } = _ref2;
  const validate = useValidation(validationRuleName);
  const warning = useValidation(warningRuleName);
  return /*#__PURE__*/_jsx(ReduxFormField, {
    component: ComboBoxComponent,
    format: format,
    name: name,
    normalize: normalize,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    props: {
      name,
      ...props
    },
    validate: validate,
    warn: warning
  });
}
export default ConnectedComboBox;
//# sourceMappingURL=ConnectedComboBox.js.map